export const baseURL = "https://server.fxbalance.ru";
